import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ANNOUNCEMENT } from '@/content/announcement';
import { Icon } from './Icon';

const STORAGE_KEY = `havorix.announcement.${ANNOUNCEMENT.id}`;

function readDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dismissed';
  } catch {
    // 隐私模式下 localStorage 可能不可用；读不到就当作未关闭。
    return false;
  }
}

/**
 * 顶部公告条。
 *
 * 不吸顶 —— 滚动时它随页面离开，顶栏自己吸住，这是阿里云的处理方式。
 * 关闭状态记进 localStorage，刷新后不会再次弹出同一条公告。
 */
export function AnnouncementBar() {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  const close = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, 'dismissed');
    } catch {
      /* 存不进去也不影响本次会话内的关闭效果 */
    }
  };

  return (
    <div className="bg-grad-band text-grad-fg">
      <div className="container-page flex items-center gap-3 py-2.5">
        <p className="min-w-0 flex-1 text-center text-[0.8125rem] leading-snug sm:text-sm">
          {ANNOUNCEMENT.text}
        </p>
        <Link
          to={ANNOUNCEMENT.action.to}
          className="hidden shrink-0 items-center gap-1 rounded-btn bg-white/92 px-3 py-1.5 text-[0.8125rem] font-medium text-[#0b3f8f] transition-colors hover:bg-white sm:inline-flex"
        >
          {ANNOUNCEMENT.action.label}
          <Icon name="arrowRight" size={13} />
        </Link>
        <button
          type="button"
          onClick={close}
          aria-label="关闭公告"
          className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-grad-fg/80 transition-colors hover:bg-white/15 hover:text-grad-fg"
        >
          <Icon name="close" size={15} />
        </button>
      </div>
    </div>
  );
}
